var exports = {
  "kL": "MfaScreen.module__container___bXpSTG",
  "DD": "MfaScreen.module__title___bXpSTG",
  "h_": "MfaScreen.module__description___bXpSTG",
  "Zd": "MfaScreen.module__form___bXpSTG",
  "_N": "MfaScreen.module__webauthnSection___bXpSTG",
  "Hq": "MfaScreen.module__footerButtons___bXpSTG",
  "wC": "MfaScreen.module__footerButton___bXpSTG",
};

module.exports = exports;
